define(['jquery', 'jquerycookie'], function ($) {
   'use strict';

   var self;

   function initializePreview() {
      var jWidget = $("#preview-widget");
      jWidget.find(".preview-toggle").click(function() {
         jWidget.toggleClass("open");
      });
      $("#exit-preview").click(function() {
         $.cookie("PreviewEnabled", null, {path : '/'});
         document.location.href = document.location.href;
      });
   }

   $(initializePreview);

   function initializeSocialLinks() {
      $(document).on("click", ".social-media a, .socialNetworks a", function (e) {
         e.preventDefault();
         window.open($(this).attr("href"), "_blank");
      });
   }

   $(initializeSocialLinks);

   self = {
      GS: ',',
      GS2: '|',
      NULL: decodeURIComponent('%18'),

      debug: function () {
         if (window.console && console.debug) {
            console.debug.apply(console, arguments);
         }
      },

      /**
       * Converts a querystring to a JSON object
       * @param strQueryString ex: "orange=orange&apple=red&banana=pink"
       * @return {object] ex: { orange: "orange", apple: "red", banana: "pink" }
       */
      queryToJSON: function (strQueryString) {
         if (!strQueryString) {
            return {};
         }

         var oResult = {},
            aList = strQueryString.split('&'),
            i = aList.length,
            aRow;

         while (i--) {
            aRow = aList[i].split('=');

            if (aRow.length === 2) {
               oResult[aRow[0]] = decodeURIComponent(aRow[1]).replace(/\+/g, ' ');
            }
         }

         return oResult;
      },

      /**
       * Compares two strings, making the assumption that
       * a null or undefined string is supposed to be equal to an empty string
       * @param {string} lhs
       * @param {string} rhs
       * @return {boolean}
       */
      nullSafeStrEquals: function (lhs, rhs) {
         if (lhs === null || lhs === undefined || lhs.length === 0) {
            lhs = null;
         }

         if (rhs === null || rhs === undefined || rhs.length === 0) {
            rhs = null;
         }

         return (rhs === lhs);
      },

      /**
       * Stop an event and prevent it from propogating up the DOM tree
       * @param {event} event
       * @return {boolean} false
       */
      stopEvent: function (event) {
         var e = event || window.event;

         if (e) {
            e.cancelBubble = true;

            if (e.stopPropagation) {
               e.stopPropagation();
            }
         }

         return false;
      },

      /**
       * Get the first key in a Javascript object
       * @param {object} data
       * @return the first key
       */
      getFirstKey: function (data) {
         var prop;

         for (prop in data) {
            if (data.hasOwnProperty(prop)) {
               return prop;
            }
         }

         return undefined;
      },

      /**
       * Determine whether a Javascript object has children
       * @param {object} data
       * @return whether the object has children
       */
      objectHasChildren: function (data) {
         var prop;

         for (prop in data) {
            if (data.hasOwnProperty(prop)) {
               return true;
            }
         }

         return false;
      },

      scrollToTop: function () {
         var iTop = Math.max($('html').scrollTop(), $('body').scrollTop()),
            oOffset = $('#PageBody').offset(),
            iBodyTop = oOffset ? oOffset.top : -1;

         if (iBodyTop > 0 && iTop > iBodyTop) {
            $('html, body').animate({
               scrollTop: iBodyTop
            }, 1000);
         }
      },

      /**
       * parseInt implementation that defaults to base 10
       * Browser implementation of parseInt DOES NOT. Try "0x755"
       * @param {string} str  the string to convert
       * @param {number} [iRadix]  the base, defaulting to 10
       * @return {number}
       */
      parseInt: function (str, iRadix) {
         var iRadixInternal = (iRadix === undefined) ? 10 : iRadix;
         return parseInt(str, iRadixInternal);
      },

      waitFor: function (fnCheck, fn) {
         if (fnCheck() === true) {
            if (fn) fn();
         } else {
            setTimeout(function () {
               self.waitFor(fnCheck, fn);
            }, 100);
         }
      },

      handleErrors: function (aStrErrors) {
         var strErrors = '';

         $.each(aStrErrors, function (i, strError) {
            strErrors += strError + '\n\n';
         });

         if (window.console) {
            console.debug(strErrors);
         }
      },

      isTouchscreen: function () {
         return (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent);
      },

      /**
       * From StackOverflow post:
       * http://stackoverflow.com/questions/14441456/how-to-detect-which-device-view-youre-on-using-twitter-bootstrap-api
       */
      findBootstrapEnvironment: function () {
          var envs = ['xs', 'sm', 'md', 'lg'],
            $el;

          $el = $('<div>');
          $el.appendTo($('body'));

          for (var i = envs.length - 1; i >= 0; i--) {
              var env = envs[i];

              $el.addClass('hidden-'+env);
              if ($el.is(':hidden')) {
                  $el.remove();
                  return env;
              }
          }
      }
   };

   return self;
});
